import Popup from '@Views/comp/Popup';
import { callService, niceCheck } from '@Views/utils/ServiceUtils';
import { isEmpty, isNull, passwordCheck, sha256 } from '@Views/utils/StringUtils';
import { useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';

const PasswordChangePopup = ({ title, popupRef, cntctEaddrRef, msg, setUserInfo, msg2 }: any) => {
  const history = useHistory();
  const params: any = useParams();
  const backUrl = params['pageUrl'] ? ('/' + params['pageUrl']) : '/';

  const passwordChange = async () => {
    const oldPassword: any = document.querySelector('#oldPassword');
    const newPassword: any = document.querySelector('#newPassword');
    const confirmPassword: any = document.querySelector('#confirmPassword');

    if (isNull(oldPassword.value)) {
      alert(msg['oldPassword'] + msg['inputCheck']);
      oldPassword.focus();
      return;
    }

    if (isNull(newPassword.value)) {
      alert(msg['newPassword'] + msg['inputCheck']);
      newPassword.focus();
      return;
    }


    if (isNull(confirmPassword.value)) {
      alert(msg['confirmPassword'] + msg['inputCheck']);
      confirmPassword.focus();
      return;
    }

    if (!passwordCheck(newPassword.value)) {
      alert(msg['passwordCheck']);
      newPassword.focus();
      return;
    }

    if (oldPassword.value === newPassword.value) {
      alert(msg['passwordVrfc']);
      newPassword.focus();
      return;
    }

    const param: any = {
      cntctEaddr: cntctEaddrRef['current']['value']
    };

    param['oldPwd'] = sha256(oldPassword.value);
    param['newPwd'] = sha256(newPassword.value);
    param['cnfmPwd'] = sha256(confirmPassword.value);

    const res = await callService("OBMUD01U02", param);

    if (res['resltCcnt'] === 1) {

      const loginParam = {
        cntctEaddr: cntctEaddrRef['current']['value'],
        ecryPwd: param['newPwd']
      }

      const userInfo = await callService("OBMUE01R01", loginParam);
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo))
      setUserInfo(userInfo);
      history.push(backUrl);
    }

  }
  return <>
    <Popup className="modal-sm change-pw" title={title} ref={popupRef}>
      <div className="modal-body">
        <p dangerouslySetInnerHTML={{ __html: msg2 }} />
        <p className="color-4c84ff" dangerouslySetInnerHTML={{ __html: msg['passwordChangeTitle2'] }} />

        <fieldset>
          <div className="form-group">
            <div className="input-box-group">
              <div className="input-box clearfix">
                <label>{msg['oldPassword']}</label>
                <div className="input-group">
                  <input className="form-control" type="password" id="oldPassword" placeholder={msg['oldPassword'] + msg['inputCheck']} />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="input-box-group">
              <div className="input-box clearfix">
                <label>{msg['newPassword']}</label>
                <div className="input-group">
                  <input className="form-control" type="password" id="newPassword" placeholder={msg['newPassword'] + msg['inputCheck']} />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="input-box-group">
              <div className="input-box clearfix">
                <label>{msg['confirmPassword']}</label>
                <div className="input-group">
                  <input className="form-control" type="password" id="confirmPassword" placeholder={msg['confirmPassword'] + msg['inputCheck']} onKeyDown={(e) => { if (e.key === 'Enter') { passwordChange() } }} />
                </div>
              </div>
            </div>
          </div>
          <div className="btn-group btn-130">
            <button type="button" className="btn btn-popup positive" onClick={passwordChange}>{msg['confirm']}</button>
          </div>
        </fieldset>
      </div>
    </Popup>
  </>
}

const Login = ({ msg, setUserInfo, userInfo }: any) => {
  const history = useHistory();
  const passwordChangePopupRef: any = useRef();
  const cntctEaddrRef: any = useRef();
  const params: any = useParams();
  const backUrl = params['pageUrl'] ? ('/' + params['pageUrl']) : '/';

  let win: any = window;

  let [selectAgePopupActive, setSelectAgePopupActive] = useState<boolean>(false);
  let [selectAge, setSelectAge] = useState<string>('A');

  let [msg2, setMsg2] = useState<any>();

  const loginClick = async () => {
    const cntctEaddr: any = document.querySelector('#cntctEaddr');
    const ecryPwd: any = document.querySelector('#ecryPwd');


    if (isNull(cntctEaddr.value)) {
      alert(msg['cntctEaddrCheck']);
      cntctEaddr.focus();
      return;
    }

    if (isNull(ecryPwd.value)) {
      alert(msg['ecryPwdCheck']);
      ecryPwd.focus();
      return;
    }

    const param = {
      cntctEaddr: cntctEaddr.value,
      ecryPwd: sha256(ecryPwd.value)
    }

    const res = await callService("OBMUE01R01", param, { errorMsgFlag: false });

    if (res['detailMsgs']) {
      const errMsg = res['detailMsgs'][0];

      const passwordChangeCodeList = ['BBME00012', 'BBME00010'];

      if (passwordChangeCodeList.indexOf(errMsg['msgCd']) !== -1) {
        if (errMsg['msgCd'] === 'BBME00010') {
          setMsg2('<strong>회원님의 비밀번호는 변경 대상입니다.</strong><br />개인정보보호를 위해 90일 이상 비밀번호를 변경하지 않은 경우<br />비밀번호 변경을 안내하고 있습니다.');
        }
        else if (errMsg['msgCd'] === 'BBME00012') {
          setMsg2('소중한 개인정보 보호를 위해 비밀번호 변경을 부탁드립니다.<br /><strong>비밀번호를 변경하여 주세요.</strong>');
        }
        passwordChangePopupRef['current'].isOpen(true);
      } else {
        let checkCnt: number = 0;
        //5회 이전 메세지
        if (errMsg['msgCtnt'].length > 65) {

          checkCnt = errMsg['msgCtnt'].substring(64, 65);

          if (checkCnt >= 5) {

            win.confirm(msg['overErrMsg'], function () {
              history.push('/PasswordFind')
            })

          } else {
            alert(errMsg['msgCtnt']);
            return;
          }
        } else {
          let regEx = /[^0-9]/g;
          checkCnt = errMsg['msgCtnt'].replace(regEx, "");
          if (!isEmpty(checkCnt) && checkCnt >= 5) {

            win.confirm(msg['overErrMsg'], function () {
              history.push('/PasswordFind')
            })
          } else {
            alert(errMsg['msgCtnt']);
            return;
          }
        }

      }
    } else {
      sessionStorage.setItem("userInfo", JSON.stringify(res));
      setUserInfo(res);
      if (res) {
        history.push(backUrl);
      }
    }
  }

  const onClickRadioAge = (e: any) => {
    const selectedStdRadio: any = document.querySelector('input[name="radio2-1"]:checked');
    setSelectAge(selectedStdRadio['value']);
  }

  const AuthKeyApplyClick1 = () => {

    if (userInfo) {
      history.push('/AuthKeyApply');
    }
    else {
      setSelectAgePopupActive(true);
    }

  }

  const AuthKeyApplyClick2 = () => {

    if (selectAge === 'A') {
      niceCheck('/api/#/AuthKeyApply');
    }
    else if (selectAge === 'B') {

    }

  }


  return (
    <>
      <div className={"modal fade" + (selectAgePopupActive ? ' show' : '')}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <strong className="modal-title"></strong>
              <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setSelectAgePopupActive(false) }}>
              </button>
            </div>
            <div className="modal-comp">
              <div className="txt-con">
                <div className="con-tit">
                  <strong className="tit">알림</strong>
                </div>
                <div className="con-desc">
                  <h4>이용자 구분 선택</h4>
                  <p><br /></p>
                  <div className="input-box">
                    <div className="input-group" style={{ textAlign: 'left', paddingLeft: '10px' }}>
                      <input type="radio" name="radio2-1" id="radio2-1" className="form-control" value="A" defaultChecked={true} onClick={onClickRadioAge} />
                      <label htmlFor="radio2-1"><span>일반 이용자(만 14세 이상)</span></label>
                    </div>
                  </div>
                  <p><br /></p>
                  {selectAge === 'A' &&
                    <p>회원가입을 위한 본인인증 절차를 진행합니다.</p>
                  }
                </div>
                <div className="btn-wrap" style={{ "textAlign": "center" }}>
                  <div className="form-group form-group-checkbox">
                    <div className="input-box-group">
                      <div className="input-box">
                        <div className="input-group">
                          <button type="button" className="btn btn-popup positive" onClick={() => { AuthKeyApplyClick2() }}>확인</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"modal-backdrop fade" + (selectAgePopupActive ? ' show' : '')}></div>

      <PasswordChangePopup popupRef={passwordChangePopupRef} msg={msg} cntctEaddrRef={cntctEaddrRef} setUserInfo={setUserInfo} msg2={msg2} />
      <div className="wrap-body" tabIndex={-1}>
        <div className="wrap-body-content">
          <section className="login-section">
            <h2>{msg['title']}</h2>
            <p dangerouslySetInnerHTML={{ __html: msg['titleDesc'] }}></p>
            <div>
              <fieldset>
                <div>
                  <div className="form-group">
                    <div className="input-box-group">
                      <div className="input-box">
                        <input className="form-control" type="text" id="cntctEaddr" placeholder={msg['cntctEaddrCheck']} ref={cntctEaddrRef} />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="input-box-group">
                      <div className="input-box">
                        <input className="form-control" type="password" id="ecryPwd" placeholder={msg['ecryPwdCheck']} onKeyDown={(e) => { if (e.key === 'Enter') { loginClick() } }} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="a-group">
                  <Link to="/PasswordFind">{msg['passwordFind']}</Link>
                  <a onClick={AuthKeyApplyClick1}>{msg['authKeyApply']}</a>
                </div>
                <div className="btn-group">
                  <button type="button" className="btn bg-4c84ff" onClick={loginClick}>{msg['title']}</button>
                </div>
              </fieldset>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
export default Login;